import React from 'react'
import {
    List,
    Datagrid,
    TextField,
    TextInput,
    Filter,
    EditButton
} from 'react-admin'

const PostFilter = (props) => (
    <Filter {...props}>
        <TextInput label="Buscar" source="search" alwaysOn />
    </Filter>
);

export const EsquemaList = props => {
    if (props.permissions === null) {
        return null
    }

    return (
        <List 
            {...props}
            filters={<PostFilter />}
            sort={{ field: 'name', order: 'ASC' }}
            exporter={false} 
        >
            <Datagrid>
                <TextField source="name" label="Nombre"/>
                <TextField source="description" label="Descripción" />
                {["admin", "coordinador"].includes(props.permissions.role) && <EditButton label={"Editar"} />}
            </Datagrid>
        </List>
    )
};
